// pages/billing.js — Billing page (2026-06-23).
//
// Owns the `data-page="billing"` section, promoted to its own top-level nav
// tab (was a panel inside the Account page). Cloud-only.
//
// Why its own page: the billing card — including the consumption usage meter —
// only rendered when something called renderBillingStatus(), and that call was
// wired to the SETTINGS page's mount. So a user who opened Account (where the
// card used to live) never triggered the render, and the "Usage (24h)" row sat
// at its `—` placeholder. Giving Billing its own page with its own mount means
// renderBillingStatus() runs every time the tab is opened — the meter always
// paints. stop() tears down the consumption countdown ticker so it doesn't run
// while the tab is hidden (the section is hidden via .active, never removed).
//
// Mirrors the bindLifecycle/start/stop + MutationObserver pattern used by every
// other page module (see pages/account.js).
import { renderBillingStatus, stopConsumptionMeter } from "../billing.js";

let started = false;

function start() {
  if (started) return;
  started = true;
  // renderBillingStatus is async + self-guards on missing DOM; fire and forget.
  renderBillingStatus().catch((err) => console.warn("billing page render failed:", err));
}

function stop() {
  if (!started) return;
  started = false;
  // Stop the usage-meter countdown ticker so it doesn't keep firing while the
  // billing tab is hidden.
  stopConsumptionMeter();
}

function bindLifecycle() {
  const section = document.querySelector('section.page[data-page="billing"]');
  if (!section) return;
  if (section.classList.contains("active")) start();
  const obs = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.attributeName !== "class") return;
      if (section.classList.contains("active")) start();
      else stop();
    });
  });
  obs.observe(section, { attributes: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindLifecycle);
} else {
  bindLifecycle();
}
